export default "__VITE_ASSET__Cq$qF7ka__"